/** Correct-answer progress + coin payout per `live_events.key` (menu / fly VFX). */

export type EventProgressRewardDef = {
  targetCorrectAnswers: number;
  rewardCoins: number;
  rewardLabel: string;
};

export const EVENT_PROGRESS_REWARDS: Record<string, EventProgressRewardDef> = {
  dessert_week: {
    targetCorrectAnswers: 8,
    rewardCoins: 75,
    rewardLabel: "Scholar stash",
  },
  spice_sprint: {
    targetCorrectAnswers: 12,
    rewardCoins: 100,
    rewardLabel: "Arena vault",
  },
  midnight_snack_rush: {
    targetCorrectAnswers: 10,
    rewardCoins: 90,
    rewardLabel: "Lab grant",
  },
};

export function eventRewardDef(key: string): EventProgressRewardDef {
  const k = key.trim();
  return (
    EVENT_PROGRESS_REWARDS[k] ?? {
      targetCorrectAnswers: 10,
      rewardCoins: 50,
      rewardLabel: "Event bonus",
    }
  );
}
